/**
 * NavigationAnalyticsTracker
 *
 * Fires a `page_view` event on every route change to BOTH:
 *   - Firebase Analytics (GA4) via setCurrentScreen + logEvent
 *   - Amplitude via amplitudeClient.logEvent
 *
 * Renders null — purely a side-effect component mounted inside <Router>.
 */
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { useFirebase } from './FirebaseContext';
import { EVENTS } from 'services/AnalyticsService';

// Human-readable page titles mapped from route prefixes
const PAGE_TITLES = {
  '/feed':            'Feed',
  '/explore':         'Explore',
  '/marketplace':     'Apex Marketplace',
  '/deals':           'Deal Finder',
  '/rocket':          'Rocket CRM',
  '/sponsorships':    'Sponsorships',
  '/profile':         'Profile',
  '/events':          'Events',
  '/social':          'Social',
  '/blast':           'Blast Dashboard',
  '/vault':           'Digital Twin Studio',
  '/auto-clip':       'Auto Clip',
  '/calendar':        'Calendar',
  '/checkout':        'Checkout',
  '/sign-in':         'Sign In',
  '/signup':          'Sign Up',
  '/forgot-password': 'Forgot Password',
  '/team':            'Team Portal',
  '/connections':     'Connections',
  '/analytics':       'Analytics',
  '/contracts':       'Contracts',
  '/beacon':          'Beacon',
  '/trust':           'Trust Portal',
  '/map':             'Nearby Map',
  '/livestream':      'Livestream',
  '/fusion':          'Fusion Hub',
};

function getPageTitle(pathname) {
  for (const [prefix, title] of Object.entries(PAGE_TITLES)) {
    if (pathname.startsWith(prefix)) return title;
  }
  return pathname;
}

export default function NavigationAnalyticsTracker() {
  const location = useLocation();
  const firebase = useFirebase();

  useEffect(() => {
    const path = location.pathname + location.search;
    const title = getPageTitle(location.pathname);

    const params = { page_path: path, page_title: title };

    try {
      firebase.analytics.setCurrentScreen(path);
      firebase.analytics.logEvent(EVENTS.PAGE_VIEW, params);
    } catch (_) {}

    try {
      firebase.amplitudeClient.logEvent(EVENTS.PAGE_VIEW, params);
    } catch (_) {}
  }, [location, firebase]);

  return null;
}